<template>
  <fullscreen style="height: 100%;" :fullscreen.sync="isFullScreen" :teleport="true" :page-only="false" ref="fullscreen"
              @change="fullscreenChange">
    <div class="amap" ref="pMap">
      <tdt-map ref="pbrMap" :center="center" :zoom="zoom" :controls="controls" @init="mapLoaded" :min-zoom="minZoom"
               :max-zoom="6"
               @click="handleMapClick" @zoomstart="handleMapZoomStart"
               :viewport="[]" @zoomend="zoomend">
        <!--            <tdt-tilelayer :url="tileUrl"></tdt-tilelayer>-->
        <!--        <tdt-tilelayer-tdt :opacity="2" :zIndex="999" :url="tileUrl"></tdt-tilelayer-tdt>-->
        <!--        <tdt-tilelayer-wms v-bind="option"></tdt-tilelayer-wms>-->
        <tdt-infowindow
            :close-on-click="true"
            :target="infowindow.target"
            :content="infowindow.content"
            @close="infowindow.target = null"
        ></tdt-infowindow>
        <!--        <tdt-marker-cluster ref="pbrMapCluster" :styles="styles" :markers="markers" @click="clusterClick"></tdt-marker-cluster>-->
        <tdt-marker style="z-index: 99999" v-for="(marker, index) in markers" :key="index" :position="marker.position"
                    :icon="marker.icon" :ext-data="marker.extData" @touchend.native.prevent="markerClick(marker)"
                    @click="markerClick(marker)"></tdt-marker>
        <template v-if="showPbrMapIcon">
          <tdt-control position="bottomright">
            <el-tooltip :content="downloadContent" :open-delay="300" effect="dark"
                        placement="left">
              <Icon type="ios-print-outline" size="14" class="pbr-map-icon"
                    @click.stop="printMap"/>
            </el-tooltip>
          </tdt-control>
          <tdt-control position="bottomright" v-show="Object.keys(responseData).length">
            <el-tooltip :content="listToolContent" :open-delay="300" effect="dark"
                        placement="left">
              <i class="el-icon-tickets pbr-map-icon" style="font-size: 14px"
                 @click.stop="gotoList"/>
            </el-tooltip>
          </tdt-control>
          <tdt-control position="bottomright">
            <Icon v-cloak :type="fullScreenIconType" size="14" class="pbr-map-icon"
                  @click.stop="toggleFullscreen"/>
          </tdt-control>
          <tdt-control ref="features" class="pbr-home-map-charts-control" position="bottomright"
                       style="position: static">
            <div class="pbr-home-map-charts">
              <div class="pbr-home-map-download leaflet-bar" style="margin-right: 10px;transform:translateY(-100px)">
                <Icon :type="eyeIconType" size="30" style="line-height: 30px" @click.stop="eyeClick"/>
              </div>
            </div>
          </tdt-control>
          <tdt-control position="bottom">
            <div class="chart-clone"></div>
          </tdt-control>
          <tdt-control position="topleft" style="margin-left: 0;margin-top: 0;height:100%;"
                       ref="pbr-home-filter-container"
                       class="pbr-home-filter-container">
            <section ref="pbr-home-filter" class="pbr-home-filter" @mouseout="controlMouseout"
                     @mouseover="controlMouseover" style="position:relative;">
              <section class="pbr-home-filter-content">
                <div class="header">
                  <!--              <Input ref="searchInput" :value="keywords" class="pbr-home-filter-input" placeholder="关键字" search-->
                  <!--                     style="margin: 10px" suffix="ios-search" @on-search="search"/>-->

                  <AutoComplete
                      ref="searchInput"
                      v-model="keywords"
                      transfer
                      clearable
                      icon="ios-search"
                      class="pbr-home-filter-input"
                      @on-focus="()=> {this.associationWordsList=[]}"
                      @on-search="associationWords"
                      @keyup.enter.native="advanceFilterOkBtnClick"
                      @on-change="autoCompleteChange"
                      @on-select="advanceFilterOkBtnClick"
                      :placeholder="$t('label.home.keywordInputPlaceholder')" style="margin: 10px">
                    <Option v-for="item in associationWordsList" :value="item" :key="item">{{ item }}</Option>
                  </AutoComplete>
                  <Icon :size="17" style="cursor: pointer;" type="ios-funnel-outline"
                        @click.stop="showAdvance = !showAdvance"/>
                </div>
                <main v-if="showAdvance" class="pbr-home-filter-advance">
                  <div class="pbr-home-filter-advance-tree-container">
                    <!-- <Tree :data="advanceFilterTreeData"
                            :render="renderadvanceFilterContent"
                            show-checkbox
                            check-directly
                            @on-check-change="advanceFilterTreeChecked"
                            ></Tree> -->

                    <el-tree ref="advanceFilterTree" :data="advanceFilterTreeData()"
                             :default-checked-keys="dafaultCheckedKeys()" :expand-on-click-node="false" :props="{
                     label: 'title',
                      //children: 'children'
                  }" check-on-click-node
                             node-key="id" show-checkbox
                             style="width:100%;padding:10px;" @check="advanceFilterTreeChecked">
                      <div slot-scope="{ node, data, el }" class="tree-node">
                        <el-tooltip :content="node.label" :disabled="isShowTooltip" :open-delay="300" effect="dark"
                                    placement="top">
                    <span class="over-ellipsis" @mouseover="treeTitleMouseOver($event)">
                      {{ node.label }}
                    </span>
                        </el-tooltip>
                      </div>
                    </el-tree>
                  </div>
                  <div class="button-group">
                    <Button size="small" @click.stop="advanceFilterCancelBtnClick">{{ $t('buttons.reset') }}</Button>
                    <Button size="small" type="primary" @click.stop="advanceFilterOkBtnClick">{{
                        $t('buttons.okButton')
                      }}
                    </Button>
                  </div>
                </main>
                <main v-else style="display: flex">
                  <div style="display: inline-block;width:50px" v-if="false">
                    <!--                && countryModels.slice(0,10)-->
                    <div v-for="country in countryModels" :key="country.id"
                         class="pbr-map-filter-country-logo-container">
                      <img :alt="country.name" :src="$pbrApis.baseUrl+country.logo" class="pbr-map-filter-country-logo"
                           @click.stop="filterDataByCountry(country)"
                           v-if="tags.length === 0 || tags.includes(country.name)">
                    </div>
                  </div>
                  <pbr-map-table v-if="mapTableShow" :map="self" :columns="[{ name: 'nationLogo',
            label: '' ,
            width: '50',slot:'img'},{ name: 'name',
            label: $t('label.home.filterTableColumnName') ,
            width: '180'}]" :params="mapTableParams" :current-module="currentTableModule"
                                 :height="pbrIndexFilterHeight"></pbr-map-table>
                </main>
              </section>
              <section class="pbr-home-filter-sort">
                <section class="pbr-home-project" @click.stop="projectSectionclick">
                  <img :src="require(`../../../../assets/images/map/project.png`)" alt=""/>
                  <span>{{ $t('label.home.map.project') }}</span>
                </section>
                <section class="pbr-home-business" @click.stop="businessSectionclick">
                  <img :src="require(`../../../../assets/images/map/business.png`)" alt=""/>
                  <span>{{ $t('label.home.map.opportunity') }}</span>
                </section>
                <section class="pbr-home-risk" @click.stop="riskSectionclick">
                  <img :src="require(`../../../../assets/images/map/risk.png`)" alt=""/>
                  <span>{{ $t('label.home.map.risk') }}</span>
                </section>
              </section>
            </section>
          </tdt-control>
          <tdt-control class="tag-control" position="topleft" style="position: absolute">
            <div class="tag-group" style="display: flex;width: 900px;flex-wrap:wrap;" @mouseover="controlMouseover"
                 @mouseout="controlMouseout">
              <el-tag v-for="tag in tags" :key="tag" :color="tagColor()" :disable-transitions="false" closable
                      effect="light"
                      hit @click.stop="drawershow = true" @close="handleFilterTagsClose(tag)">
                {{ tag }}
              </el-tag>
            </div>
          </tdt-control>
        </template>
      </tdt-map>
    </div>
    <!--    <div id="pbr-icon-base64-render-container" style="display: flex; justify-content: center; align-items: center;width:25px;position:relative">-->
    <!--      <img src="static/images/pbr/dw-business.png" style="width:25px;height:25px;">-->
    <!--      <span style="position: absolute;font-size: 12px; transform: translateY(-10%)">3</span>-->
    <!--    </div>-->
  </fullscreen>
</template>

<script>
import '@/untils/map.js'
import VueFullscreen from 'vue-fullscreen'
import Vue from 'vue'
import {sStorage} from '../../common/utils/storage'
import emitter from 'element-ui/src/mixins/emitter'
import html2canvas from 'html2canvas'
import PbrMapTable from './MapTable'
import {delay} from 'lodash'

Vue.use(VueFullscreen)

const CustomForeach = async (arr, callback) => {
  const length = arr.length
  const O = Object(arr)
  let k = 0
  while (k < length) {
    if (k in O) {
      console.log('doing foreach...')
      const kValue = O[k]
      await callback(kValue, k, O)
    }
    k++
  }
}

export default {
  name: 'PbrTdtMap',
  componentName: 'pbrTdtMap',
  components: {PbrMapTable},
  mixins: [emitter],
  inject: ['loadMapDataError', 'updateSpinShow', 'updateEmphasesCategory', 'mapDataLoadFinished', 'hideContainer', 'windowResize'],
  data () {
    return {
      mapTableShow: false,
      mapMarkerIconServer: `${this.$pbrApis.baseUrl}/front/home/getLogoPic?`, // 'http://0.0.0.0:3000/image?',
      sectionMouseOver: false,
      isFullScreen: false, // 全屏
      teleport: true, // 如果为true， 进入全屏时目标元素会被移动到document.body下。这可以避免一些弹窗在全屏模式下看不到的问题。
      map: null, // 天地图实例
      baseTitleUrl: 'https://t0.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=ed564f9c0ee383bb453cd76d135c8fee',
      tileUrl: 'https://t0.tianditu.gov.cn/eva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=eva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=ed564f9c0ee383bb453cd76d135c8fee',
      tileLabelUrl: 'https://t0.tianditu.gov.cn/eva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=ed564f9c0ee383bb453cd76d135c8fee',
      center: [39.875960, 7.931600], // 初始化地图中心点 [53.417674,33.629593][54.006387,31.542586][116.4035797119, 39.9044690755]
      zoom: 2, // 初始化地图缩放比例
      minZoom: 1,
      controls: [{name: 'copyright', position: 'topright'}, {name: 'scale', position: 'bottomright'}], // ['OverviewMap','search', 'mapType', {name: 'scale', position: 'bottomright'}, {name: 'zoom', position: 'bottomright'}, 'copyright', {name: 'overviewMap', position: 'bottomright'},], // 初始化地图默认控件
      markers: [],
      styles: [],
      option: {
        url: 'https://t0.tianditu.gov.cn/eva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=eva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=ed564f9c0ee383bb453cd76d135c8fee',
        version: '1.1.1',
        transparent: false,
        styles: '',
        format: 'image/png'
      },
      infowindow: {
        content: '',
        target: []
      },
      showPbrMapIcon: false, // 地图加载完毕后显示自定义控件
      self: this,
      associationWordsList: [], // 自动完成表单
      timestep: 0,
      isShowTooltip: false,
      eyeIconType: 'ios-eye-off-outline', // 地图全屏后显示图表的按钮
      iconSize: [30, 30],
      iconAnchor: [0, 0],
      drawershow: false,
      responseData: {},
      showAdvance: false,
      hiddenTooltip: true,
      metaData: {},
      pbrIndexFilter: null,
      currentTableModule: null,
      mapTableParams: {},
      pbrIndexFilterHeight: 400,
      xmConditions: [], // 项目查询条件
      sjConditions: [], // 商机查询条件
      fxConditions: [], // 风险查询条件
      geojsonListForMap: [], // geojson数据
      treeParams: {}, // 高级筛选数据
      keywords: '', // 检索关键字
      tags: [], // 检索条件
      countryModels: [],
      pbrIndexCharts: null,
      fullScreenIconType: 'ios-expand',
      count: 0,
      isDataByAdvance: false,
      isResize: false,
    }
  },
  computed: {
    /**
     * 是否深色模式
     * @returns {boolean}
     */
    isDark () {
      return this.$store.state.brpaModule.theme === 'dark'
    },
    /**
     * gotoList按钮的tooltip的content
     * @returns {*}
     */
    listToolContent () {
      return this.$t(`label.home.map.tooltip.${this.currentTableModule || 'xm'}`)
    },

    downloadContent () {
      return this.$t(`label.home.map.download`)
    }
  },
  mounted () {
    this.$on('fetchDataByChartData', this.fetchDataByChartData)
    window.addEventListener('resize', this.resize)
  },
  destroyed () {
    window.removeEventListener('resize',this.resize)
  },
  methods: {
    /**
     * 天地图初始化的回调方法
     * @param map
     */
    mapLoaded (map) {
      this.map = map
      this.isDark && map.setStyle('indigo')
      if (localStorage.getItem('locale') === 'en') {
        let layers = map.getLayers()
        map.removeLayer(layers[1])
        var lay = new T.TileLayer(this.tileUrl, {minZoom: 1, maxZoom: 18})
        map.addLayer(lay)
      }
      this.showPbrMapIcon = true
      this.initPage()
      // 监控Dom变化
      let pMapDom = this.$refs.pMap
      let that = this;
      let countContrastObserver = new ResizeObserver((entries) => {
        if (that.isResize) {
          this.$refs.pbrMap.getMap().checkResize()
          if (entries && entries.length > 0 && entries[0].borderBoxSize[0].blockSize > 0) {
            that.isResize = false;
          }
        }
      })
      countContrastObserver.observe(pMapDom);

    },
    /**
     * 地图缩放后的触发事件
     * @param type
     * @param target
     */
    zoomend ({type, target}) {
      //
      // 1-2: continentList
      // 3-5: nationList
      // 5-6: List
      let zoom = this.$refs.pbrMap.getMap().getZoom()
      if (zoom < 3) {
        this.geojsonListForMap = this.responseData.continentList || []
        this.generateMapData(this.responseData.continentList || [])
      } else if (zoom > 2 && zoom < 5) {
        this.geojsonListForMap = this.responseData.nationList || []
        this.generateMapData(this.responseData.nationList || [])
      } else if (zoom > 4) {

        this.geojsonListForMap = this.responseData.list || []
        this.generateMapData(this.responseData.list || [])
      }

      console.log('地图缩放比例： ', this.$refs.pbrMap.getMap().getZoom())
    },
    /**
     * 地图标记被点击事件
     * @param e
     */
    markerClick (e) {
      let {extData,} = e
      let {detail, fields, category} = extData
      console.log(extData)
      let popupContent = ''
      if (detail.name) {
        popupContent +=
            '<span class="attribute"><span class="label">' +
            fields.name +
            ':</span> ' +
            detail.name +
            '</span>'
      }

      for (let [key, value] of Object.entries(fields)) {
        if (key === 'name') {
          continue
        } else if (detail.country) {
          if (detail.id && category === 'project') {
            popupContent += `<span class="attribute"><span class="label">${this.$t('label.home.map.country')}: </span>${detail.country}</span>
                            <span class="attribute"><span class="label">${this.$t('label.home.map.number')}: </span>${detail.num}</span>
                        `
            break
          } else if (detail.id && (category === 'business' || category === 'risk')) {
            let label = value
            let val = detail[key] || '--'
            popupContent +=
                '<span class="attribute"><span class="label">' +
                label +
                ':</span> ' +
                val +
                '</span>'
          } else {
            let zoom = this.$refs.pbrMap.getMap().getZoom()
            this.$refs.pbrMap.getMap().setZoom(zoom + 1)
            return
          }

        } else {
          let label = value
          let val = detail[key] || '--'
          popupContent +=
              '<span class="attribute"><span class="label">' +
              label +
              ':</span> ' +
              val +
              '</span>'
        }
      }

      let router_pbr_subs = this.$router.options.routes.find(r => r.name === 'pbr').children
      // let enum_path = {
      //   // 'categoryField'
      //   'project': detail.country ? `${router_pbr_subs.find(r => r.name === 'pbrProject').path}?key=${detail.id}&n=${detail.country}` : `${router_pbr_subs.find(r => r.name === 'pbrProjectDetail').path}?key=${detail.id}`,
      //   'business': `${router_pbr_subs.find(r => r.name === 'pbrInfo').path}?key=${detail.id}&n=${detail.country}&tabPath=bl`,
      //   'risk': `${router_pbr_subs.find(r => r.name === 'pbrInfo').path}?key=${detail.id}&n=${detail.country}&tabPath=r`
      // }

      let enum_path = {
        project: {
          path: detail.country ? router_pbr_subs.find(r => r.name === 'pbrProject').path : router_pbr_subs.find(r => r.name === 'pbrProjectDetail').path,
          query: {
            key: detail.id,
            [detail.country ? 'n' : '']: detail.country
          }
        },
        business: {
          path: router_pbr_subs.find(r => r.name === 'pbrInfo').path,
          query: {
            key: detail.id,
            n: detail.country,
            tabPath: 'sj'
          }
        },
        risk: {
          path: router_pbr_subs.find(r => r.name === 'pbrInfo').path,
          query: {
            key: detail.id,
            n: detail.country,
            tabPath: 'fxsj'
          }
        }
      }
      // href="#${enum_path[category]}"
      popupContent += `<a onclick="info_window_redirect()"  style="display:flex; justify-content:flex-end;margin: 7px 0;">${this.$t('buttons.home.mapDetailButton')}</a>`
      popupContent = '<div class="map-popup">' + popupContent + '</div>'
      this.infowindow = {
        target: e.position,
        content: popupContent,
        route: enum_path[category]
      }
    },

    info_window_redirect (e) {

      let self = this
      let {path, query} = this.infowindow.route
      if (!path || !query || !Object.keys(query).length) {
        return
      }

      if(path.startsWith("/pbr/project/detail")){
        if (this.$refs.fullscreen.isFullscreen){
          this.isFullScreen = false
          delay(function (e) {
            self.redirectTo({
              path,
              query
            })
          }, 3000)
        } else {
          self.redirectTo({
            path,
            query
          })
        }
        return;
      }

      // 国家ID
      // query.key
      var countryKey = query.key
      // 国家名称
      // query.n
      var countryN = query.n



      if (this.$refs.fullscreen.isFullscreen){
        this.isFullScreen = false
        delay(function (e) {
          let enum_router = {
            xm: 'pbrProject',
            sj: 'pbrInfo',
            fx: 'pbrInfo'
          }
          let pbrIndexModule = self.getPBRIndexModule()
          let currentModule = pbrIndexModule.currentModule
          let currentModuleParams = pbrIndexModule[currentModule].params
          let currentModuleTags = pbrIndexModule[currentModule].tags

          // 设置选中的国家
          if(!currentModuleParams.country){
            currentModuleParams.country = countryKey;
            currentModuleParams.searchkeys.push(countryN)
            currentModuleTags.push({
              id: countryKey,
              type: 'country',
              title: countryN
            })
          }

          currentModuleParams.country = countryKey;
          let delCountry = [];
          // 循环找到所有未选择的国家
          currentModuleTags.forEach(function (v, k) {
            if (v.type === 'country') {
              if(v.title === countryN){
              }else{
                delCountry.push(v.title);
              }
            }
          })

          currentModuleTags = currentModuleTags.filter(item => {
            return item.type != 'country' || (item.type === 'country' && item.title === countryN);
          })

          currentModuleParams.searchkeys = currentModuleParams.searchkeys.filter(item => {
            var delFlag = true
            delCountry.forEach(function(dv, dk){
              if(dv === item){
                delFlag = false;
              }
            })
            return delFlag;
          })
          self.$router.push({
            name: enum_router[currentModule],
            params: {
              currentModuleParams,
              currentModuleTags,
              tabPath: currentModule === 'xm' ? 'xm' : currentModule === 'sj' ? 'sj' : 'fxsj'
            }
          })

        }, 3000, this)
      } else {
        delay(function (e) {
          let enum_router = {
            xm: 'pbrProject',
            sj: 'pbrInfo',
            fx: 'pbrInfo'
          }
          let pbrIndexModule = self.getPBRIndexModule()
          let currentModule = pbrIndexModule.currentModule
          let currentModuleParams = pbrIndexModule[currentModule].params
          let currentModuleTags = pbrIndexModule[currentModule].tags

          // 设置选中的国家
          if(!currentModuleParams.country){
            currentModuleParams.country = countryKey;
            currentModuleParams.searchkeys.push(countryN)
            currentModuleTags.push({
              id: countryKey,
              type: 'country',
              title: countryN
            })
          }

          currentModuleParams.country = countryKey;
          let delCountry = [];
          // 循环找到所有未选择的国家
          currentModuleTags.forEach(function (v, k) {
            if (v.type === 'country') {
              if(v.title === countryN){
              }else{
                delCountry.push(v.title);
              }
            }
          })

          currentModuleTags = currentModuleTags.filter(item => {
            return item.type != 'country' || (item.type === 'country' && item.title === countryN);
          })

          currentModuleParams.searchkeys = currentModuleParams.searchkeys.filter(item => {
            var delFlag = true
            delCountry.forEach(function(dv, dk){
              if(dv === item){
                delFlag = false;
              }
            })
            return delFlag;
          })
          debugger
          self.$router.push({
            name: enum_router[currentModule],
            params: {
              currentModuleParams,
              currentModuleTags,
              tabPath: currentModule === 'xm' ? 'xm' : currentModule === 'sj' ? 'sj' : 'fxsj'
            }
          })

        }, 1000, this)
      }

    },
    redirectTo(obj){
      this.$router.push(obj)
    },

    /**
     * 切换全屏
     */
    toggleFullscreen () {
      this.isFullScreen = !this.isFullScreen
    },
    fullscreenChange (isFullScreen) {
      this.fullScreenIconType = isFullScreen ? 'ios-contract' : 'ios-expand'
      setTimeout(() => {
        this.generateEyeControl(isFullScreen)
      }, 500)

    },
    gotoList () {
      let self = this
      this.isFullScreen = false
      delay(function (e) {
        let enum_router = {
          xm: 'pbrProject',
          sj: 'pbrInfo',
          fx: 'pbrInfo'
        }
        let pbrIndexModule = self.getPBRIndexModule()
        let currentModule = pbrIndexModule.currentModule
        let currentModuleParams = pbrIndexModule[currentModule].params
        let currentModuleTags = pbrIndexModule[currentModule].tags
        self.$router.push({
          name: enum_router[currentModule],
          params: {
            currentModuleParams,
            currentModuleTags,
            tabPath: currentModule === 'xm' ? 'xm' : currentModule === 'sj' ? 'sj' : 'fxsj'
          }
        })
      }, 3000, this)
    },
    /**
     * 下载地图图片
     */
    printMap () {
      let that = this
      let a = document.createElement('a')
      html2canvas(document.querySelector('.tdt-map-pane'), {
        useCORS: true
      }).then(canvas => {
        let dom = document.body.appendChild(canvas)
        dom.style.display = 'none'
        a.style.display = 'none'
        document.body.removeChild(dom)
        let blob = that.dataURLToBlob(dom.toDataURL('image/png'))
        a.setAttribute('href', URL.createObjectURL(blob))
        // 这块是保存图片操作  可以设置保存的图片的信息
        a.setAttribute('download', 'map_clip_share' + '.png')
        document.body.appendChild(a)
        a.click()
        URL.revokeObjectURL(blob)
        document.body.removeChild(a)
        //this.$iMessage.destroy()
      })
    },
    /**
     * 将图片信息转换Blob格式
     * @param dataurl
     * @returns {Blob}
     */
    dataURLToBlob (dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {type: mime})
    },
    convertToImage (options = {}, num, type = 'risk') {
      //
      let html = `<div id="pbr-icon-base64-render-container" style="display: flex; justify-content: center; align-items: center;width:25px;position:relative">
      <img src="static/images/pbr/dw-${type}.png" style="width:25px;height:25px;">
      <span style="position: absolute;font-size: 12px; transform: translateY(-10%)">${num}</span>
    </div>`
      var divTemp = document.createElement('div')
      divTemp.innerHTML = html
      this.$refs.fullscreen.$el.append(divTemp)
      let container = document.querySelector('#pbr-icon-base64-render-container')
      // 设置放大倍数
      const scale = window.devicePixelRatio

      // 传入节点原始宽高
      const _width = container.offsetWidth
      const _height = container.offsetHeight

      let {width, height} = options
      width = width || _width
      height = height || _height

      // html2canvas配置项
      const ops = {
        // scale,
        width,
        height,
        // canvas: canvas, //自
        useCORS: true,
        allowTaint: false,
        backgroundColor: 'transparent',
        ...options
      }

      return html2canvas(container, ops).then(canvas => {
        // 返回图片的二进制数据
        // this.$refs.fullscreen.$el.remove(divTemp)
        document.querySelector('#pbr-icon-base64-render-container').remove()
        return canvas.toDataURL('image/png')
      })
    },
    filterActive () {
      //  pbr-home-filter

      this.$refs['pbr-home-filter-container'].$el.classList.add('pbr-home-filter-active')
      this.mapTableShow = true
      document.querySelector('.tag-control').classList.add('tag-control-transx')
      this.pbrIndexFilter = document.querySelector('.pbr-home-filter')
      this.pbrIndexFilterHeight =
          parseInt(window.getComputedStyle(this.pbrIndexFilter).height) - 80 + 'px'
    },
    /**
     * 点击漂层显示相应图表
     */
    filterSortActive (currentTarget) {
      let activeDom = document.querySelector('.pbr-home-filter-sort .is-active')
      activeDom && activeDom.classList.remove('is-active')
      document.querySelector('.' + currentTarget.classList[0]).classList.add('is-active')
    },
    /**
     * 地图控件区域内禁止双击放大
     */
    controlMouseover () {
      this.$refs.pbrMap.getMap().disableScrollWheelZoom()
      this.$refs.pbrMap.getMap().disableDoubleClickZoom()
      this.$refs.pbrMap.getMap().disablePinchToZoom()
      this.sectionMouseOver = true
    },
    /**
     * 地图控件区域外允许双击放大
     */
    controlMouseout () {
      this.$refs.pbrMap.getMap().enableScrollWheelZoom()
      this.$refs.pbrMap.getMap().enableDoubleClickZoom()
      this.$refs.pbrMap.getMap().enablePinchToZoom()
      this.sectionMouseOver = false
    },
    /**
     * 获取当前激活的module
     * @returns {any}
     */
    getPBRIndexModule () {
      let pbrIndexModuleStr = sStorage.get('pbrIndexModule')
      let pbrIndexModule = pbrIndexModuleStr ? JSON.parse(pbrIndexModuleStr) : {}
      return pbrIndexModule
    },
    /**
     * 更新当前激活的module缓存
     * @param origin: 原值
     * @param newObj: 现值（覆盖值）
     */
    setPBRIndexModule (origin, newObj) {
      let pbrIndexModule = Object.assign({}, origin, newObj)
      sStorage.set('pbrIndexModule', pbrIndexModule)
    },

    /**
     * 自动完成表单数据请求
     * @param keyword: 文本框输入
     */
    associationWords (keyword) {
      if (keyword && keyword.length > 100) {
        //this.$iMessage.error({content: this.$t('message.error.maximum100'), duration: 5})
        return
      }
      // type（0项目搜索   1项目资讯搜索  2商机资讯搜索   3风险资讯搜索   4风险事件搜索  5分析页搜索）
      let types = {
        xm: 0,
        sj: 2,
        fx: 4
      }

      this.$pbrApis.associationWords({keyword, type: types[this.currentTableModule]}).then(res => {
        if (res.success) {
          this.associationWordsList = res.result.models
        }
      })
    },

    /**
     * 跟进当前module过滤地图顶部tag标签
     */
    filterTags () {
      let pbrIndexModule = this.getPBRIndexModule()
      if (pbrIndexModule.currentModule === '') {
        return []
      }
      // let pbrIndexModule = this.$store.getters.pbrIndexModule
      let currentModule = pbrIndexModule.currentModule
      let currentModuleTags = pbrIndexModule[currentModule].tags

      return currentModuleTags ? currentModuleTags.map(item => item.title || item.name) : []
    },
    /**
     * 根据主题切换tag的样式
     * @returns {string}
     */
    tagColor () {
      return this.isDark ? '#0D2E53' : '#fff'
    },
    /**
     * 高级检索数据来源
     * @returns {*}
     */
    advanceFilterTreeData () {
      let pbrIndexModule = this.getPBRIndexModule()
      // let pbrIndexModule = this.$store.getters.pbrIndexModule
      let currentModule = pbrIndexModule.currentModule
      if (
          !pbrIndexModule[currentModule].advanceConditions
      ) {
        return this[currentModule + 'Conditions']
      } else {
        return pbrIndexModule[currentModule].advanceConditions
      }
    },
    /**
     * 高级检索，默认选中结点
     * @returns {string[]}
     */
    dafaultCheckedKeys () {
      let pbrIndexModule = this.getPBRIndexModule()
      // let pbrIndexModule = this.$store.getters.pbrIndexModule
      let currentModule = pbrIndexModule.currentModule
      let currentParams = pbrIndexModule[currentModule].params

      let {
        country = '',
        category = '',
        date = '',
        industry = '',
        company = '',
        amount = '',
        stage = ''
      } = currentParams
      let keys = country.split(',').filter(item => item !== '')
      keys = keys.concat([], category.split(',').filter(item => item !== ''))
          .concat([], date.split(',').filter(item => item !== ''))
          .concat([], industry.split(',').filter(item => item !== ''))
          .concat([], company.split(',').filter(item => item !== ''))
          .concat([], amount.split(',').filter(item => item !== ''))
          .concat([], stage.split(',').filter(item => item !== ''))

      return keys
    },
    /**
     * 关键字来源
     * @returns {string}
     */
    filterKeyword () {
      let pbrIndexModule = this.getPBRIndexModule()
      // let pbrIndexModule = this.$store.getters.pbrIndexModule
      let currentModule = pbrIndexModule.currentModule
      if (
          !pbrIndexModule.currentModule ||
          !pbrIndexModule[currentModule]
      ) {
        return ''
      }
      let keywords = pbrIndexModule[currentModule].params.keywords || ''
      return keywords.trim()
    },
    /**
     * 高级检索叶子结点添加tooltip提示
     */
    treeTitleMouseOver (event) {
      this.isShowTooltip =
          event.currentTarget.scrollWidth <= event.currentTarget.clientWidth
    },
    /**
     * 左侧 项目 图标 点击事件
     * @param e
     */
    projectSectionclick (e) {
      this.zoom = 2
      this.infowindow = {}
      let that = this
      this.updateSpinShow(true)
      let eb = e.currentTarget
      this.updateEmphasesCategory('xm')
      let pbrIndexModule = this.getPBRIndexModule()
      this.treeParams.country = pbrIndexModule.xm.params.country;
      let {currentModule} = pbrIndexModule
      this.keywords = pbrIndexModule.xm.params.keywords || ''
      if (currentModule === '' || currentModule !== 'xm') {
        this.setPBRIndexModule(pbrIndexModule, {
          currentModule: 'xm'
        })
        currentModule = 'xm'
      }
      let params = this.renderLoadParams({
        module: 'xm'
      })

      params.searchkeys = currentModule && currentModule.length > 0 && pbrIndexModule[currentModule].tags.map(item => item.title)

      // this.mapTableParams = params
      this.currentTableModule = 'xm'
      if (pbrIndexModule.xm.mapData && Object.keys(pbrIndexModule.xm.mapData).length > 0) {
        this.mapTableParams = params
        that.$refs.pbrMap.getMap().setZoom(this.zoom)
        this.responseData = pbrIndexModule.xm.mapData
        this.loadConditionsData('xm')
        this.geojsonListForMap = pbrIndexModule.xm.mapData.continentList || []
        this.generateMapData(pbrIndexModule.xm.mapData.continentList || [])
        this.filterSortActive(e.currentTarget)
        this.loadCharts(pbrIndexModule.xm.mapData)
        that.tags = that.filterTags()
        that.filterActive()
        return
      }

      // let params = this.renderLoadParams({
      //   module: 'xm'
      // })

      this.loadData(params, () => {
        that.loadConditionsData('xm')
        that.keywords = that.filterKeyword()
        that.tags = that.filterTags()
        that.filterActive()
        that.filterSortActive(eb)
      })
    },
    /**
     * 左侧 商机 图标 点击事件
     * @param e
     */
    businessSectionclick (e) {
      this.zoom = 2
      this.infowindow = {}
      this.resetClusterIcon('business')
      let that = this
      this.updateSpinShow(true)
      let eb = e.currentTarget
      this.updateEmphasesCategory('sj')
      let pbrIndexModule = this.getPBRIndexModule()
      this.treeParams.country = pbrIndexModule.sj.params.country;
      let {currentModule} = pbrIndexModule
      this.keywords = pbrIndexModule.sj.params.keywords || ''
      if (currentModule === '' || currentModule !== 'sj') {
        this.setPBRIndexModule(pbrIndexModule, {
          currentModule: 'sj'
        })
        // this.$store.commit('pbrIndexModule', {
        //   currentModule: 'sj'
        // })
        currentModule = 'sj'
      }
      let params = this.renderLoadParams({
        module: 'sj'
      })
      params.searchkeys = currentModule && currentModule.length > 0 && pbrIndexModule[currentModule].tags.map(item => item.title)
      // this.mapTableParams = params

      this.currentTableModule = 'sj'
      if (pbrIndexModule.sj.mapData && Object.keys(pbrIndexModule.sj.mapData).length > 0) {
        this.mapTableParams = params
        that.$refs.pbrMap.getMap().setZoom(this.zoom)
        this.responseData = pbrIndexModule.sj.mapData
        this.geojsonListForMap = pbrIndexModule.sj.mapData.continentList || []
        this.generateMapData(pbrIndexModule.sj.mapData.continentList || [])
        this.loadCharts(pbrIndexModule.sj.mapData)
        this.filterSortActive(e.currentTarget)
        this.loadConditionsData('sj')
        that.filterActive()
        that.tags = that.filterTags()
        return
      }
      // let params = this.renderLoadParams({
      //   module: 'sj'
      // })

      this.loadData(params, () => {
        that.loadConditionsData('sj')
        that.keywords = that.filterKeyword()
        that.tags = that.filterTags()
        that.filterSortActive(eb)
        that.filterActive()
      })
    },
    /**
     * 左侧 风险 图标 点击事件
     * @param e
     */
    riskSectionclick (e) {
      this.zoom = 2
      this.infowindow = {}
      this.resetClusterIcon('risk')
      let that = this
      this.updateSpinShow(true)
      let eb = e.currentTarget
      this.updateEmphasesCategory('fx')
      let pbrIndexModule = this.getPBRIndexModule()
      this.treeParams.country = pbrIndexModule.fx.params.country;
      let {currentModule} = pbrIndexModule
      this.keywords = pbrIndexModule.fx.params.keywords || ''
      if (currentModule === '' || currentModule !== 'fx') {
        this.setPBRIndexModule(pbrIndexModule, {
          currentModule: 'fx'
        })
        currentModule = 'fx'
        // this.$store.commit('pbrIndexModule', {
        //   currentModule: 'fx'
        // })
      }
      let params = this.renderLoadParams({
        module: 'fx'
      })
      params.searchkeys = currentModule && currentModule.length > 0 && pbrIndexModule[currentModule].tags.map(item => item.title)
      // this.mapTableParams = params
      this.currentTableModule = 'fx'
      if (pbrIndexModule.fx.mapData && Object.keys(pbrIndexModule.fx.mapData).length > 0) {
        this.mapTableParams = params
        that.$refs.pbrMap.getMap().setZoom(this.zoom)
        this.responseData = pbrIndexModule.fx.mapData
        this.geojsonListForMap = pbrIndexModule.fx.mapData.continentList || []
        this.generateMapData(pbrIndexModule.fx.mapData.continentList || [])
        this.loadCharts(pbrIndexModule.fx.mapData)
        this.filterSortActive(e.currentTarget)
        this.loadConditionsData('fx')
        that.filterActive()
        that.tags = that.filterTags()
        return
      }

      this.loadData(params, () => {
        that.loadConditionsData('fx')
        that.keywords = that.filterKeyword()
        that.tags = that.filterTags()
        that.filterSortActive(eb)
        that.filterActive()
      })
    },
    /**
     * 聚合图标
     * @param type
     */
    resetClusterIcon (type) {
      this.clusterIconType = type
      let that = this

      this.styles = []
      this.styles = [{
        url: `static/images/pbr/dw-${type}${that.isDark ? '-dark' : ''}.png`,
        size: [25, 25], // 图片大小
        offset: [-15, -13], // 显示图片的偏移量
        textColor: that.isDark ? '#ebedee' : '#000000', // 显示数字的颜色
        textSize: 8, // 显示文字的大小
        range: [0, 500] // 显示该图标的范围
      }]
    },
    /**
     * 编辑查询条件
     */
    renderLoadParams (params = {}) {
      let {
        from = 'cn'
      } = params
      let newParams = {
        from
      }
      let pbrIndexModule = this.getPBRIndexModule()
      let currentModule = pbrIndexModule.currentModule
      let currentParams = pbrIndexModule[currentModule].params
      return Object.assign({}, newParams, currentParams, params)
    },
    /**
     * 地图全屏后右侧 眼睛icon 点击事件
     */
    eyeClick () {
      document
          .querySelector('.chart-clone')
          .classList.toggle('chart-clone-hidden')
      this.eyeIconType =
          this.eyeIconType === 'ios-eye-outline'
              ? 'ios-eye-off-outline'
              : 'ios-eye-outline'
    },
    /**
     * 地图点击隐藏漂层
     */
    handleMapClick (type, target, lnglat, containerPoint) {
      if (this.sectionMouseOver) {
        return
      }
      this.$refs['pbr-home-filter-container'].$el.classList.remove('pbr-home-filter-active')
      this.mapTableShow = false
      document.querySelector('.tag-control').classList.remove('tag-control-transx')
      //   this.filterSortActive()
    },
    handleMapZoomStart ({type, target}) {
      console.log(target)
    },
    /**
     * 点击首页图表，按条件检索地图数据
     */
    fetchDataByChartData (params) {
      let self = this
      let currentModule = params.module
      let pbrIndexModule = this.getPBRIndexModule()
      //   let currentModule = params.module
      // this.$store.commit('pbrIndexModule', {
      //   currentModule: 'xm'
      // })
      let currentModuleTags = pbrIndexModule[currentModule].tags

      let tagIndex = currentModuleTags.findIndex((value, index, arr) => {
        return value.id === params.condition.id
      })

      var i = currentModuleTags.length
      while (i--) {
        if (currentModuleTags[i].type === params.condition.type) {
          currentModuleTags.splice(i, 1)
        }
      }

      // if (tagIndex > -1) {
      //   currentModuleTags[tagIndex] = params.condition
      // } else {
      currentModuleTags.push(params.condition)
      // }

      this.setPBRIndexModule(pbrIndexModule, {
        currentModule: currentModule,
        [currentModule]: {
          ...pbrIndexModule[currentModule],
          tags: currentModuleTags
        }
      })

      let currentModuleParams = this.renderLoadParams({
        module: params.module,
        [params.condition.type]: params.condition.id
      })

      this.loadData(currentModuleParams, () => {
        self.keywords = self.filterKeyword()
        self.tags = self.filterTags()
      })
    },
    /**
     * 通过国家变化检索数据
     * @param country
     */
    filterDataByCountry (country) {
      let self = this

      let pbrIndexModule = this.getPBRIndexModule()
      let currentModule = pbrIndexModule.currentModule
      let currentModuleTags = pbrIndexModule[currentModule].tags
      let tagIndex = currentModuleTags.findIndex((value, index, arr) => {
        return value.id === country.id
      })
      if (tagIndex > -1) {

      } else {
        country.title = country.name
        currentModuleTags.push({type: 'country', ...country})
      }

      this.setPBRIndexModule(pbrIndexModule, {
        currentModule: currentModule,
        [currentModule]: {
          ...pbrIndexModule[currentModule],
          tags: currentModuleTags
        }
      })

      let currentModuleParams = this.renderLoadParams({
        module: currentModule,
        'country': currentModuleTags.map(c => c.id).join(',')
      })

      this.loadData(currentModuleParams, () => {
        self.keywords = self.filterKeyword()
        self.tags = self.filterTags()
      })
    },

    /**
     * tag关闭时，减少相应的检索数据，重新检索
     */
    handleFilterTagsClose (tag) {
      // let pbrIndexModule = this.$store.getters.pbrIndexModule
      let pbrIndexModule = this.getPBRIndexModule()
      let currentModule = pbrIndexModule.currentModule
      let currentModuleParams = pbrIndexModule[currentModule].params
      let currentModuleTags = pbrIndexModule[currentModule].tags
      let tagIndex = currentModuleTags.findIndex((value, index, arr) => {
        return value.title === tag || value.name === tag
      })

      // currentModuleParams[currentModuleTags[tagIndex].type] = ''
      for (let k in currentModuleParams) {
        if (k === 'searchkeys') {

        } else {
          let pindex = currentModuleParams[k].split(',').findIndex(i => i === currentModuleTags[tagIndex].id)
          if (pindex > -1) {
            let sk = currentModuleParams['searchkeys']
            let ta = currentModuleParams[k].split(',')
            if (sk.indexOf(ta.name) > -1) {
              sk.splice(sk.indexOf(ta.name), 1)
            }

            ta.splice(pindex, 1)
            currentModuleParams[k] = ta.join(',')
          }

          if(this.treeParams.hasOwnProperty(k)){
            let tindex = this.treeParams[k].split(',').findIndex(i => i === currentModuleTags[tagIndex].id)
            if (tindex > -1) {
              let array = this.treeParams[k].split(',')
              array.splice(tindex, 1)
              this.treeParams[k] = array.join(',')
            }
          }

        }
      }
      currentModuleTags.splice(tagIndex, 1)
      if (currentModuleParams.keywords === tag) {
        currentModuleParams.keywords = ''
      }

      this.setPBRIndexModule(pbrIndexModule, {
        [currentModule]: {
          ...pbrIndexModule[currentModule],
          params: currentModuleParams,
          tags: currentModuleTags
        }
      })
      let self = this

      this.loadData(currentModuleParams, () => {
        self.keywords = self.filterKeyword()
        self.tags = self.filterTags()
      })
    },
    /**
     * 获取地图检索数据
     */
    loadData (params = {}, callback) {
      this.markers = []
      this.responseData = {}
      let that = this
      let self = this
      let pbrIndexModule = this.getPBRIndexModule()
      // this.clearMap()
      this.loadMapDataError(false)
      let currentModule = pbrIndexModule.currentModule
      this.updateSpinShow(true)
      params.searchkeys = currentModule && currentModule.length > 0 && pbrIndexModule[currentModule].tags.map(item => item.title)
      this.mapTableParams = Object.assign({}, params)

      if (currentModule !== '') {
        this.setPBRIndexModule(pbrIndexModule, {
          [currentModule]: {
            ...pbrIndexModule[currentModule],
            'params': params
          }
        })
      }

      this.$pbrAxios.post('/front/home/search', params)
          .then((res) => {
            if(that.$refs.pbrMap.getMap()){
              that.$refs.pbrMap.getMap().setZoom(this.zoom)
            }
            if (!res) {
              //self.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
              self.loadMapDataError(true)
            } else if (res.code === 200) {
              let data = res.result
              this.responseData = data
              this.metaData = data.options
              self.loadCharts(res.result)

              if (this.zoom === 2) {
                this.geojsonListForMap = data.continentList || []
                self.generateMapData(data.continentList || [])
              } else {
                this.geojsonListForMap = data.nationList || []
                self.generateMapData(data.nationList || [])
              }

              let pbrIndexModule = this.getPBRIndexModule()
              let currentModule = pbrIndexModule.currentModule
              self.setPBRIndexModule(pbrIndexModule, {
                [currentModule]: {
                  ...pbrIndexModule[currentModule],
                  mapData: res.result
                }
              })

            } else {
              //self.$iMessage.error({content: this.$t('message.error.noData'), duration: 5})
              self.listData = []
              self.mapDataLoadFinished(null)
              self.loadMapDataError(true)
            }
            callback && callback()
          })
          .catch((error) => {
            //self.$iMessage.error({content: error.message, duration: 5})
            self.loadMapDataError(true)
          }).finally(() => {
        self.keywords = self.filterKeyword()
        self.tags = self.filterTags()
      })
    },
    /**
     * 高级检索条件
     */
    loadConditionsData (type = 'xm', from = 'cn') {
      let pbrIndexModule = this.getPBRIndexModule()
      let currentModule = pbrIndexModule.currentModule || 'xm'
      if (pbrIndexModule[currentModule] && pbrIndexModule[currentModule].countryModels && pbrIndexModule[currentModule].countryModels.length !== 0) {
        this.countryModels = pbrIndexModule[currentModule].countryModels
        return
      }
      let self = this
      this.$pbrApis.fetchMapGConditions({
        from: from,
        type: type
      })
          .then((res) => {
            if (!res) {
            } else if (res.code === 200) {
              // let pbrIndexModule = self.$store.getters.pbrIndexModule
              self.countryModels = res.result.countryModels
              let advanceConditions = this.advanceConditionRecurred(res.result.models)
              this.setPBRIndexModule(pbrIndexModule, {
                [currentModule]: {
                  ...pbrIndexModule[currentModule],
                  countryModels: res.result.countryModels,
                  advanceConditions: advanceConditions
                }
              })

              self[type + 'Conditions'] = advanceConditions
              self[type + 'Conditions'].countryModels = res.result.countryModels
            } else {
              self.listData = []
            }
          })
          .catch((error) => {
            //this.$iMessage.error(error)
            console.error(error)
          })
    },
    advanceConditionRecurred (advanceConditions, conditionType) {
      let Conditions = advanceConditions
      let conditionTypeEnum = {
        '国家': 'country',
        '行业': 'industry',
        '企业': 'enterprise',
        '类别': 'category',
        '阶段': 'stage',
        '金额': 'amount',
        '日期': 'signDate',
        'Country': 'country',
        'Industry': 'industry',
        'Enterprise': 'company',
        'Type': 'category',
        'Value': 'amount',
        'Phases': 'stage',
        'Date': 'date'
      }

      Conditions.forEach((item, index) => {
        if(item.title == "日期" || item.title == "Date"){
          item.disabled = true;
        }
        if (item.hasOwnProperty('children')) {
          this.advanceConditionRecurred(item.children, conditionType || conditionTypeEnum[item.title])
        } else {
          item.type = conditionType
        }
      })

      return Conditions
    },
    /**
     * 高级检索结点添加tooltip
     */
    titleMouseOver (e) {
      let parentWidth = e.currentTarget.parentNode.offsetWidth
      let contentWidth = e.currentTarget.scrollWidth
      // 判断是否开启tooltip功能
      if (contentWidth > parentWidth) {
        this.hiddenTooltip = false
      } else {
        this.hiddenTooltip = true
      }
    },
    /**
     * 渲染高级检索条件树
     */
    renderadvanceFilterContent (h, {
      root,
      node,
      data
    }) {
      let self = this
      return h('Tooltip', {
        props: {
          content: data.title,
          placement: 'right',
          'max-width': '100',
          transfer: true,
          disabled: this.hiddenTooltip,
          delay: 1000
        }
      }, [

        h('span', {
          style: {
            display: 'inline-block',
            maxWidth: '100px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
          },
          on: {
            mouseover: this.titleMouseOver
          }
        }, [h('span', data.title)])

      ])
    },
    /**
     * 加载渲染下方图表
     * @param data
     */
    loadCharts (data) {
      console.log("loadCharts====================================")
      this.mapDataLoadFinished({
        projectIndustryChart: data.projectIndustryChart,
        projectNationChart: data.projectNationChart,
        projectNumChart: data.projectNumChart,
        riskLineChart: data.riskLineChart,
        riskNationChart: data.riskNationChart,
        riskTypeChart: data.riskTypeChart,
        businessCountryChart: data.businessCountryChart,
        businessLineChart: data.businessLineChart,
        businessTypeChart: data.businessTypeChart
      })
    },
    /**
     * 设置地图渲染和显示
     * @param list
     */
    generateMapData (list) {
      // this.responseData = data
      // this.metaData = data.options
      // this.geojsonListForMap = data.list
      // if (list.length === 0) {
      //   return
      // }
      this.isResize = true
      this.renderMap()
      let zoom = this.$refs.pbrMap.getMap().getZoom()
      let center = list && list.length > 0 && list[0].features[0].geometry.coordinates
      if (center && this.isDataByAdvance) {
        this.center = center
        this.isDataByAdvance = false
      }
      // this.map.centerAndZoom(center, this.zoom)

      // this.generatePrintControl()
      this.updateSpinShow(false)
    },
    clearMap () {
    },
    /**
     * 渲染地图
     */
    renderMap () {
      let that = this
      let marks = []
      this.markers = marks

      for (let featureGroup of that.geojsonListForMap) {
        for (let feature of featureGroup.features) {
          let iconUrl = ''
          if (feature && feature.properties.categoryField === 'project') {
            iconUrl = `static/images/pbr/${(feature.properties.detail.type ? `${feature.properties.detail.type}` : '基建类')}.png`
            if (feature.properties.detail.country) {
              iconUrl = `${that.mapMarkerIconServer}type=${feature.properties.categoryField}&theme=${that.$store.state.brpaModule.theme}&num=${feature.properties.detail.num}`
            }
          } else {
            iconUrl = `${that.mapMarkerIconServer}type=${feature.properties.categoryField}&theme=${that.$store.state.brpaModule.theme}&num=${feature.properties.detail.num}`
          }

          let marker = {
            position: feature.geometry.coordinates,
            icon: {iconUrl: iconUrl, iconSize: [35, 35]},
            edit: true,
            extData: {
              detail: feature.properties.detail,
              fields: that.metaData.fields[feature.properties.categoryField],
              category: feature.properties.categoryField
            }
          }

          marks.push(marker)
        }
      }
      that.markers = marks
    },
    /**
     * 全屏时，显示右侧 显示/隐藏 图表按钮
     * @param isFullscreen
     */
    generateEyeControl (isFullscreen) {
      let self = this
      if (!document.querySelector('.pbr-index-charts')) {
        document.querySelector('.pbr-index-map') && document.querySelector('.pbr-index-map').parentNode.appendChild(self.pbrIndexCharts)
      }

      self.pbrIndexCharts = document.querySelector('.pbr-index-charts')

      let pbrIndexChartsWidth = window.getComputedStyle(self.pbrIndexCharts).width
      // 监听地图全屏事件，摆放图表控件位置

      if (isFullscreen) {
        document.querySelector('.chart-clone').appendChild(self.pbrIndexCharts).style.width = pbrIndexChartsWidth
        self.$refs.features.$el.classList.remove(
            'pbr-home-map-charts-control'
        )
        self.pbrIndexFilterHeight = 'calc(100vh - 100px)'
        this.zoom = 5
      } else {
        this.zoom = 3
        self.$refs.features.$el.classList.add(
            'pbr-home-map-charts-control'
        )
        if (document.querySelector('.chart-clone').children.length > 0) {
          document.querySelector('.chart-clone').removeChild(self.pbrIndexCharts)
        }

        document
            .querySelector('.pbr-index-map')
            .parentNode.appendChild(self.pbrIndexCharts)
        this.windowResize()
        this.pbrIndexFilter = document.querySelector('.pbr-home-filter')
        this.pbrIndexFilterHeight =
            parseInt(window.getComputedStyle(this.pbrIndexFilter).height) - 80 + 'px'
      }
    },
    /**
     * 通过高级检索条件，生成检索条件
     */
    advanceFilterTreeChecked (data, event, position) {
      if(data.type == "signDate" || data.type == "date"){
        let checkedNodes = event.checkedNodes
        let checkedKeys = event.checkedKeys
        let removeId = "";
        let removeObj = null;

        checkedNodes.forEach(cn => {
          if ((cn.type == "signDate" || cn.type == "date") && cn.id != data.id) {
            // 删除对应的ID
            removeId = cn.id;
            removeObj = cn;
          }
        })
        if(removeId != ""){
          this.$refs.advanceFilterTree.setChecked(removeId, false, false)
          // 删除Tag
          this.filterTreeSelectedData(removeObj, true)

          for (var i = 0; i < event.checkedNodes.length; i++) {
            if (event.checkedNodes[i].id == removeId) {
              event.checkedNodes.splice(i, 1)
            }
          }

          for (var i = 0; i < event.checkedKeys.length; i++) {
            if (event.checkedKeys[i] == removeId) {
              event.checkedKeys.splice(i, 1)
            }
          }
        }
      }
      let fdata = event.checkedNodes.filter(e => e == data)
      let isRemove = false
      if (data.children && !fdata.length) {
        isRemove = true
      }

      this.filterTreeSelectedData(data, isRemove)
      this.treeParams = this.generateParamsByTree(data, event)

    },
    /**
     * 操作 高级检索 树 数据
     * @param selectData
     */
    filterTreeSelectedData (selectData, isRemove) {
      if (selectData.children) {
        selectData.children.forEach(c => {
          this.filterTreeSelectedData(c, isRemove)
        })
      } else if (selectData.id) {
        this.editModuleTags(selectData, isRemove)
      }
    },
    editModuleTags (obj, isRemove) {
      let pbrIndexModule = this.getPBRIndexModule()
      let currentModule = pbrIndexModule.currentModule
      let currentModuleTags = pbrIndexModule[currentModule].tags

      let index = currentModuleTags && currentModuleTags.findIndex((value, index, arr) => {
        return value.id === obj.id
      })
      if (index > -1) {
        // currentModuleTags[index] = obj
        currentModuleTags.splice(index, 1)
      } else {
        if (!isRemove) {
          currentModuleTags.push(obj)
        }
      }
      this.setPBRIndexModule(pbrIndexModule, {
        [currentModule]: {
          ...pbrIndexModule[currentModule],
          tags: currentModuleTags
        }
      })
    },
    /**
     * 高级检索条件
     */
    generateParamsByTree (selectedData, selectedObjects) {
      // this.filterTreeSelectedData(selectedData)
      let pbrIndexModule = this.getPBRIndexModule()
      let checkedNodes = selectedObjects.checkedNodes
      let halfCheckedNodes = selectedObjects.halfCheckedNodes
      let checkedKeys = selectedObjects.checkedKeys

      let joinValue = ''
      let responseObj = {}
      let categoryObj = {
        '国家': 'country',
        '行业': 'industry',
        '企业': 'company',
        '类别': 'category',
        '金额': 'amount',
        '阶段': 'stage',
        '日期': 'date',
        'Country': 'country',
        'Industry': 'industry',
        'Enterprise': 'company',
        'Type': 'category',
        'Value': 'amount',
        'Phases': 'stage',
        'Date': 'date'
      }
      let params = pbrIndexModule[pbrIndexModule.currentModule].params
      for (const categoryObjKey in categoryObj) {
        delete params[categoryObj[categoryObjKey]]
      }

      this.setPBRIndexModule(pbrIndexModule, {
        [pbrIndexModule.currentModule]: {
          ...pbrIndexModule[pbrIndexModule.currentModule],
          params: params
        }
      })

      checkedNodes.forEach(cn => {
        if (cn.children) {
          if (cn.children[0].children) {
            joinValue = cn.children.map(a => {
              return a.children.map(i => i.id)
            }).join(',')
            responseObj.country = joinValue
          } else {
            let selectIndex = this.advanceFilterTreeData().findIndex(i => i.title === cn.title)
            if (selectIndex > -1) {
              joinValue = cn.children.map(a => a.id).join(',')
              responseObj[categoryObj[cn.title]] = joinValue
            }
          }
        }
      })
      let arr = []
      halfCheckedNodes.forEach(hcn => {
        if (hcn.children[0].children) {
          hcn.children.forEach(i => {
            let tempArr = i.children.filter(ii =>
                checkedKeys.includes(ii.id)
            ).map(i => i.id)
            if (tempArr.length > 0) {
              arr = arr.concat(tempArr)
            }
          })
          responseObj[categoryObj[hcn.title]] = arr.join(',')
        } else {
          let checkNodes = hcn.children.filter(i => checkedKeys.includes(i.id) && !arr.includes(i.id))
          if (checkNodes.length > 0) {
            responseObj[categoryObj[hcn.title]] = checkNodes.map(a => a.id).join(',')
          }
        }
      })

      return responseObj
    },
    /**
     * 关键字检索地图数据
     */
    search (e) {
      let pbrIndexModule = this.getPBRIndexModule()
      // let pbrIndexModule = this.$store.getters.pbrIndexModule
      let currentModule = pbrIndexModule.currentModule
      let currentModuleTags = pbrIndexModule[currentModule].tags

      let index = currentModuleTags && currentModuleTags.findIndex((value, index, arr) => {
        return e.target.value.id === value
      })
      if (index > -1) {
        currentModuleTags[index] = {
          title: e.target.value,
          id: e.target.value
        }
      } else {
        currentModuleTags.push({
          title: e.target.value,
          id: e.target.value
        })
      }

      this.setPBRIndexModule(pbrIndexModule, {
        [currentModule]: {
          ...pbrIndexModule[currentModule],
          tags: currentModuleTags
        }
      })

      let params = this.renderLoadParams({
        keywords: e.target.value
      })

      this.loadData(params, () => {

      })
    },
    /**
     * 高级搜索自动完成表单，选择后 触发事件
     * @param value
     */
    autoCompleteChange (value) {
      if (!value || value === '') {
        this.$refs.searchInput.$refs.input.currentValue = ''
        this.advanceFilterOkBtnClick()
      }
    },
    /**
     * 高级查询，取消 按钮点击事件
     */
    advanceFilterCancelBtnClick () {
      this.tags = []
      this.treeParams = {}
      let pbrIndexModule = this.getPBRIndexModule()
      let currentModule = pbrIndexModule.currentModule
      this.setPBRIndexModule(pbrIndexModule, {
        [currentModule]: {
          params: {}, tags: []
        }
      })
      // sStorage.set('pbrIndexModule', { currentModule: '', sj: { params: {}, tags: [] }, xm: { params: {}, tags: [] }, fx: { params: {}, tags: [] } })
      this.$refs.advanceFilterTree.setCheckedNodes([])
      this.$refs.searchInput.$refs.input.currentValue = ''

      this.loadData({module: currentModule}, () => {
        // this.keywords = this.filterKeyword()
        // this.tags = this.filterTags()
      })

    },
    /**
     * 高级查询，确定 按钮点击事件
     * @param value
     */
    advanceFilterOkBtnClick (value) {
      this.isDataByAdvance = true
      this.zoom = 4
      if (this.keywords && this.keywords.length > 100) {
        //this.$iMessage.error({content: this.$t('message.error.maximum100'), duration: 5})
        return
      }
      let self = this
      let params = {
        ...this.renderLoadParams(this.treeParams),
        keywords: typeof a === 'string' ? value : this.$refs.searchInput.$refs.input.currentValue.trim()
      }
      this.showAdvance = false
      this.loadData(params, () => {
        self.keywords = self.filterKeyword()
        self.tags = self.filterTags()
      })
    },
    /**
     * 页面初始化
     */
    initPage () {
      let self = this
      setTimeout(() => {
        // let pbrIndexModule = this.getPBRIndexModule()
        // let currentModule = pbrIndexModule.currentModule

        // this.pbrIndexFilter = document.querySelector('.pbr-home-filter')
        this.pbrIndexFilterHeight =
            parseInt(window.getComputedStyle(this.pbrIndexFilter).height) - 30 + 'px'
        if(that.$refs.pbrMap.getMap()){
          that.$refs.pbrMap.getMap().setZoom(this.zoom)
        }
        if (this.zoom === 2) {
          this.geojsonListForMap = data.continentList || []
          self.generateMapData(data.continentList || [])
        } else {
          this.geojsonListForMap = data.nationList || []
          self.generateMapData(data.nationList || [])
        }

        // let pbrIndexModule = this.getPBRIndexModule()
        // let currentModule = pbrIndexModule.currentModule
        // self.setPBRIndexModule(pbrIndexModule, {
        //   [currentModule]: {
        //     ...pbrIndexModule[currentModule],
        //     mapData: res.result
        //   }
        // })
        // let params = {from: 'cn'}
        // if (currentModule !== '') {
        //   this.updateEmphasesCategory(currentModule)
        //   this.currentTableModule = currentModule
        //   // params = {...params, ...pbrIndexModule[currentModule].params}
        //   if (pbrIndexModule[currentModule].mapData && Object.keys(pbrIndexModule[currentModule].mapData).length > 0) {
        //     this.generateMapData(pbrIndexModule[currentModule].mapData)
        //     this.loadCharts(pbrIndexModule[currentModule].mapData)
        //     this.filterActive()
        //     return
        //   }
        // } else {
        //   this.setPBRIndexModule(pbrIndexModule, {
        //     currentModule: 'xm'
        //   })

        //   this.currentTableModule = 'xm'
        //   params = this.renderLoadParams({
        //     module: 'xm'
        //   })
        //   this.updateEmphasesCategory('xm')
        // }

        // self.loadData(params, () => {
        //   self.keywords = self.filterKeyword()
        //   self.tags = self.filterTags()
        // })
      }, 300)
    },
    resize () {
      this.isResize = true;
    }
  },
  created () {
    let self = this
    setTimeout(() => {
      let pbrIndexModule = this.getPBRIndexModule()
      let currentModule = pbrIndexModule.currentModule
      let params = {from: 'cn'}
      if (currentModule !== '') {
        this.updateEmphasesCategory(currentModule)
        this.currentTableModule = currentModule
        // if (pbrIndexModule[currentModule].mapData && Object.keys(pbrIndexModule[currentModule].mapData).length > 0) {
        //   this.generateMapData(pbrIndexModule[currentModule].mapData)
        //   this.loadCharts(pbrIndexModule[currentModule].mapData)
        //   this.filterActive()
        //   return
        // }
      } else {
        this.setPBRIndexModule(pbrIndexModule, {
          currentModule: 'xm'
        })

        this.currentTableModule = 'xm'
        params = this.renderLoadParams({
          module: 'xm'
        })
        this.updateEmphasesCategory('xm')
      }

      self.loadData(params, () => {
        self.keywords = self.filterKeyword()
        self.tags = self.filterTags()
      })
    }, 500)
  },
  activated () {
    window.info_window_redirect = this.info_window_redirect
  },
  deactivated () {
    window.info_window_redirect = undefined
  },
  watch: {
    '$store.state.brpaModule.theme':
        {
          handler: function (val) {
            // 切换地图模式
            if (val === 'dark') {
              this.map && this.map.setStyle('indigo')
            } else {
              this.map && this.map.removeStyle()
            }
            if (this.map) {
              let zoom = this.map.getZoom()
              let newzoom = zoom === 1 ? this.zoom : zoom - 1

              this.map.setZoom(newzoom)
            }

            // this.resetClusterIcon(this.clusterIconType)
            // this.map && this.map.clearOverLays() && this.renderMap()// this.map.centerAndZoom([54.006387, 31.542586], 3)
          },
          immediate: true
        }

  }
}
</script>

<style scoped>
.fullscreen {
  z-index: 9999999;
}

.pbr-home-filter-sort .is-active {
  color: #2d8cf0;
  font-weight: 500;
  transform: scale(1.1);
}

.tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  /* padding-right: 8px; */
}

.over-ellipsis {
  display: block;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: 1;
}

.pbr-map-filter-country-logo {
  background: rgb(152, 255, 221);
  /* height: 25px; */
  width: 30px;
  margin: 5px;
}

.pbr-map-filter-country-logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.pbr-map-cluter-group {
  position: relative;
  transform: scale(0.7);

}

.pbr-map-cluter-group section {
  height: 35px;
  width: 35px;
  line-height: 30px;
  transition: 1.5s all;
}

.pbr-map-cluter-group :nth-child(2) {
  /*transform: translate(20px, 20px) rotate(100deg);*/
  transform: translate(15px, 28px) rotate(120deg);
  position: absolute;
  top: 0;
}

.pbr-map-cluter-group :nth-child(3) {
  /*transform: translate(-20px, 20px) rotate(260deg);*/
  transform: translate(-15px, 28px) rotate(240deg);
  position: absolute;
  top: 0;
}

.pbr-map-icon {
  line-height: 14px;
  padding: 2px;
  box-shadow: 0 0 3px;
  cursor: pointer;
  border-radius: 3px;
  background: #fff;
}

.amap >>> .tdt-top.tdt-left:nth-child(1) {
  height: 100%;
}

.amap >>> .tdt-map-pane {
  height: 100%;
  width: 100%;
}
</style>
<style lang="scss" scoped>

@mixin does-parent-exist {
  @if & {
    &:hover {
      color: red;
    }
  } @else {
    a {
      color: red;
    }
  }
}
</style>
